import { Flowstep, Operation, ProviderType } from 'shared/types/flowstep';
import { toQueryString } from 'shared/utils/utils';

/**
 * URL pattern is currently structured as:
 *   /home/flowsteps/{provider}{operation}/{id}/
 *
 * Future migration plan:
 * After completing Salesforce integration, we'll update the pattern to:
 *   /home/flowsteps/{operation}/{provider}/{id}/
 *
 */
export const getRoute = (
  id: Flowstep['id'] | null,
  operation: Operation,
  provider: ProviderType,
  params: Record<string, string> = {},
): string => {
  let url = `/home/flowsteps/${provider}/${operation}/${id || ''}`;
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => searchParams.set(key, value));
  searchParams.size > 0 && (url += `?${searchParams.toString()}`);

  return url;
};
